import "./Ramadan.css";
import "./Ramadan-Tab.css";
import "./Ramadan-Mob.css";
import BackgroundSlider from "./../slider/BackgroundSlider";
import { useEffect, useRef, useState } from "react";
import RamadanState from "./state/RamadanState";
import RamadanTown from "./town/RamadanTown";
import {
  requestGetDate,
  requestGetTimeFasting,
  requestGetFooter,
} from "./../../api/api.ramadan";
import {
  currentDate,
  monthsHalf,
  monthsIslamic,
  hour24,
  hour12,
  hour24Arr,
  convertDate,
} from "../../utils/utils";
import { getZone, API_KEY } from "./../../api/api";
import { StorageFasting } from "./../../data/StorageFasting";
import { setKey, setLanguage, setRegion, fromLatLng } from "react-geocode";

const Ramadan = () => {
  // Date
  const [date, setDate] = useState("Memuat...");
  // State
  const dialogState = useRef();
  const [idState, setIdState] = useState();
  const [stateName, setStateName] = useState("Pilih Negeri");
  // Zone
  const dialogTown = useRef();
  const defaultTimeCode = "Pilih Zone";
  const [timeCode, setTimeCode] = useState(defaultTimeCode);
  // Address
  const [address, setAddress] = useState(null);
  const [locality, setLocality] = useState(null);
  // Times
  const [imsak, setImsak] = useState(null);
  const [maghrib, setMaghrib] = useState(null);
  // Timer
  const timerImsak = useRef();
  const timerMaghrib = useRef();
  const [countdownImsak, setCountdownImsak] = useState(null);
  const [countdownMaghrib, setCountdownMaghrib] = useState(null);
  const objImsak = {
    time: null,
    date: null,
    type: "imsak",
  };
  const objMaghrib = {
    time: null,
    date: null,
    type: "maghrib",
  };
  const database = new StorageFasting();
  const isWSet = useRef(false);
  // Footer
  const [imgFooter, setImageFooter] = useState("./img_pattern.jpg");

  // Auto Locations
  const handleSuccessLocation = (position) => {
    const { latitude, longitude } = position.coords;
    //const latitude = 3.246905;
    //const longitude = 101.702859;
    getAddress(latitude, longitude);
  };
  const handleErrorLocation = (err) => {
    // If Denied
    alert(err.message);
    //console.error(err.message);
    loadLocalData();
  };
  const locationPermission = () => {
    if (!navigator.geolocation) {
      //setError("Geolocation is not supported by your browser.");
      return;
    }
    // Request permission and get current position
    navigator.geolocation.getCurrentPosition(
      handleSuccessLocation,
      handleErrorLocation,
    );
  };
  function getAddress(lat, long) {
    const country = "country";
    const state = "administrative_area_level_1";
    const town = "locality";
    const town2 = "political";
    const level2 = "administrative_area_level_2";
    var countryName = null;
    var stateName = null;
    var townName = null;
    var town2Name = null;
    // var level2Name = null;
    fromLatLng(lat, long)
      .then((response) => {
        const addresses = response.results[0].address_components;
        //console.log(addresses);
        addresses.forEach((item, i) => {
          const types = item.types;
          const type = types[0];
          if (type === country) {
            countryName = item.long_name;
          }
          if (type === state) {
            stateName = item.long_name;
          }
          if (type === town) {
            townName = item.long_name;
          }
          if (type === town2) {
            town2Name = item.long_name;
          }
          if (type === level2 && town2Name == null) {
            town2Name = item.long_name;
          }
          if (town2Name == null) {
            town2Name = townName;
          }
          setLocality(`(${town2Name})`);
        });
        //console.log(addresses);
        getZone(countryName, stateName, townName, town2Name).then((result) => {
          const stateId = result.id_state;
          const state = result.state;
          const location = result.locations;
          var zone = result.zone;
          if (zone) {
            // Ids
            database.setStateId(stateId);
            setIdState(stateId);
            // State Name
            database.setState(state);
            setStateName(state);
            // Time Code
            database.setCode(zone);
            setTimeCode(zone);
            // Town
            database.setTown(location);
            setAddress(`${zone} - ${location}`);
            getTime(zone);
          } else {
            loadLocalData();
          }
        });
      })
      .catch((error) => {
        console.error(error);
        //setAddress("Error fetching address.");
      });
  }

  function loadLocalData() {
    var getStateId = database.getStateId();
    if (getStateId == null) {
      getStateId = "25";
      database.setStateId(getStateId);
    }
    setIdState(getStateId);

    var getState = database.getState();
    if (getState == null) {
      getState = "Johor";
      database.setState(getState);
    }
    setStateName(getState);

    var getCode = database.getCode();
    if (getCode == null) {
      getCode = "JOH01";
      database.setCode(getCode);
    }
    setTimeCode(getCode);

    var getTown = database.getTown();
    if (getTown == null) {
      getTown = "Pulau Aur dan Pulau Pemanggil.";
      database.setTown(getTown);
    }
    setAddress(`${getCode} - ${getTown}`);
    const zone = database.getCode();
    getTime(zone);
  }

  // On Start
  useEffect(() => {
    getDate();
    getFooter();
    setKey(API_KEY);
    setLanguage("ms");
    setRegion("MY");
    locationPermission();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getFooter() {
    requestGetFooter().then((response) => {
      const result = response.result;
      if (result.length > 0) {
        setImageFooter(result[0].image);
      }
    });
  }

  function getDate() {
    requestGetDate(currentDate()).then((response) => {
      const result = response.result;
      const mDayIslamic = result.day;
      const dayIslamic =
        mDayIslamic < 10 ? `0${mDayIslamic}` : `${mDayIslamic}`;
      const mMonthIslamic = result.month;
      const monthIslamic = monthsIslamic[mMonthIslamic - 1];
      const yearIslamic = result.year;
      const dtIslamic =
        `${dayIslamic} ${monthIslamic} ${yearIslamic}H`.toUpperCase();
      // Date
      const dt = new Date();
      const mDay = dt.getDate();
      const day = mDay < 10 ? `0${mDay}` : `${mDay}`;
      const mMonth = dt.getMonth();
      const month = monthsHalf[mMonth];
      const year = dt.getFullYear();
      const dtf = `${day} ${month} ${year}`.toUpperCase();
      setDate(`${dtIslamic} / ${dtf}`);
    });
  }

  // State
  function onClickState() {
    dialogState.current?.show();
  }
  function onStateSelect(id, name) {
    setIdState(id);
    setTimeout(() => {
      setStateName(name);
      // Reset
      setTimeCode(defaultTimeCode);
      setAddress(null);
      setImsak(null);
      setMaghrib(null);
      stopTimerImsak();
      stopTimerMaghrib();
    }, 200);
  }

  // Town
  function onClickTown() {
    if (idState) {
      dialogTown.current?.show(idState);
    }
  }
  function onTownSelect(zone, townName) {
    setTimeout(() => {
      setTimeCode(zone);
      setAddress(zone + " - " + townName);
      database.setStateId(idState);
      database.setState(stateName);
      database.setTown(townName);
      database.setCode(zone);
      getTime(zone);
    }, 200);
  }

  // Time
  function getTime(zone) {
    requestGetTimeFasting(zone).then((response) => {
      const result = response.result;
      var mTimesToday = null;
      if (result.length > 0) {
        mTimesToday = result[0];
      }
      var mTimeTomorrow = null;
      if (result.length > 1) {
        mTimeTomorrow = result[1];
      }
      if (mTimesToday) {
        const dt = new Date();
        var timeArr = hour24Arr(mTimesToday.maghrib);
        var dtTarget = new Date();
        dtTarget.setHours(timeArr[0], timeArr[1], 0);
        const diffMaghrib = dtTarget.getTime() - dt.getTime();
        const afterMaghrib = parseInt(diffMaghrib) < 1000;
        // Imsak
        dtTarget = new Date();
        timeArr = hour24Arr(mTimesToday.imsak);
        //dtTarget.setDate(dtTarget.getDate() + 1);
        dtTarget.setHours(timeArr[0], timeArr[1], 0);
        const diffImsak = dtTarget.getTime() - dt.getTime();
        const afterImsak = diffImsak < 1000;
        const dateToday = mTimesToday.date;
        if (afterMaghrib && mTimeTomorrow) {
          const dateTomorrow = mTimeTomorrow.date;
          dataImsak(mTimeTomorrow.imsak, dateTomorrow);
          dataMaghrib(mTimeTomorrow.maghrib, dateTomorrow);
          //alert("After Maghrib");
        } else if (afterImsak && mTimeTomorrow) {
          const dateTomorrow = mTimeTomorrow.date;
          dataImsak(mTimeTomorrow.imsak, dateTomorrow);
          dataMaghrib(mTimesToday.maghrib, dateToday);
          //alert("After Imsak");
        } else {
          dataImsak(mTimesToday.imsak, dateToday);
          dataMaghrib(mTimesToday.maghrib, dateToday);
          //alert("Before Imsak");
        }
        startTimerImsak();
        startTimerMaghrib();
        setTimeout(() => {
          if (!isWSet.current) {
            setFixedW("countdown-imsak");
            setFixedW("countdown-maghrib");
            isWSet.current = true;
          }
        }, 1500);
      }
    });
  }

  function dataImsak(time, date) {
    objImsak.time = time;
    objImsak.date = date;
    setImsak({
      time: time,
      date: date,
    });
  }

  function dataMaghrib(time, date) {
    objMaghrib.time = time;
    objMaghrib.date = date;
    setMaghrib({ time: time, date: date });
  }

  function setFixedW(id) {
    const cdElement = document.getElementById(id);
    const rect = cdElement.getBoundingClientRect();
    const rW = rect.width;
    const w = rW + 12;
    cdElement.style.width = w + "px";
  }

  function startTimerImsak() {
    if (timerImsak.current) {
      stopTimerImsak();
    }
    timerImsak.current = setInterval(() => {
      count(objImsak);
    }, 1000);
  }

  function startTimerMaghrib() {
    if (timerMaghrib.current) {
      stopTimerMaghrib();
    }
    timerMaghrib.current = setInterval(() => {
      count(objMaghrib);
    }, 1000);
  }

  function stopTimerImsak() {
    clearInterval(timerImsak.current);
    timerImsak.current = null;
    setCountdownImsak(null);
  }

  function stopTimerMaghrib() {
    clearInterval(timerMaghrib.current);
    timerMaghrib.current = null;
    setCountdownMaghrib(null);
  }

  function count(target) {
    const type = target.type;
    const isImsak = type === "imsak";
    const isMaghrib = type === "maghrib";

    const now = Date.now();
    var [hours, minutes] = hour24(target.time).split(":");
    hours = parseInt(hours);
    minutes = parseInt(minutes);
    var [year, month, day] = target.date.split("-");
    year = parseInt(year);
    month = parseInt(month);
    day = parseInt(day);

    const dtTarget = new Date();
    dtTarget.setFullYear(year, month - 1, day);
    dtTarget.setHours(hours, minutes, 0);

    var remain = (dtTarget - now) / 1000;
    const hh = pad((remain / 60 / 60) % 60);
    const mm = pad((remain / 60) % 60);
    const ss = pad(remain % 60);
    const fullTime = `${hh} jam ${mm} minit ${ss} saat`;
    if (isImsak) {
      setCountdownImsak(fullTime);
    } else if (isMaghrib) {
      setCountdownMaghrib(fullTime);
    }
    const isEnd = hh === 0 && mm === 0 && ss <= 0;
    if (isEnd) {
      if (isImsak) {
        stopTimerImsak();
        // onTimerEnd();
      } else if (isMaghrib) {
        stopTimerMaghrib();
        // onTimerEnd();
      }
    }
    // const currentDay = new Date().getDate();
    // props.onTick(currentDay);
  }

  function pad(num) {
    const numb = "0" + parseInt(num);
    const last = numb.length;
    return numb.substring(last - 2, last);
  }

  // Footer
  function onClickFooter() {
    window.open("https://dana.e-waktusolat.my", "_blank");
  }

  return (
    <div className="ramadan-root">
      <BackgroundSlider />
      <div className="ramadan-content">
        <span className="ramadan-date">{date}</span>
        <div className="ramadan-spinner" onClick={() => onClickState()}>
          <span>{stateName}</span>
          <i className="material-icons">location_on</i>
        </div>
        <div className="ramadan-spinner" onClick={() => onClickTown()}>
          <span>{timeCode}</span>
          <i className="material-icons">location_on</i>
        </div>
        <span className="ramadan-address">{address}</span>
        <span className="ramadan-address-local">{locality}</span>
        <div className="ramadan-time-container">
          <div className="ramadan-times">
            <span className="ramadan-times-date">
              {imsak ? convertDate(imsak.date) : null}
            </span>
            <span className="ramadan-times-title">IMSAK</span>
            <span className="ramadan-times-time">
              {imsak ? hour12(hour24(imsak.time)) : "Memuat..."}
            </span>
            <span id="countdown-imsak" className="ramadan-times-countdown">
              {countdownImsak ? `(${countdownImsak})` : "(Memuat...)"}
            </span>
          </div>
          <div className="ramadan-time-separator" />
          <div className="ramadan-times">
            <span className="ramadan-times-date">
              {maghrib ? convertDate(maghrib.date) : null}
            </span>
            <span className="ramadan-times-title">BERBUKA</span>
            <span className="ramadan-times-time">
              {maghrib ? hour12(hour24(maghrib.time)) : "Memuat..."}
            </span>
            <span id="countdown-maghrib" className="ramadan-times-countdown">
              {countdownMaghrib ? `(${countdownMaghrib})` : "(Memuat...)"}
            </span>
          </div>
        </div>
      </div>
      <div className="ramadan-footer" onClick={() => onClickFooter()}>
        <img src={imgFooter} alt="" />
      </div>
      <RamadanState ref={dialogState} onSelect={onStateSelect} />
      <RamadanTown ref={dialogTown} onSelect={onTownSelect} />
    </div>
  );
};

export default Ramadan;
